export default class BirthDateRangeValidationExtension {
    public init(): void {
// This code is intended to be used with BirthDateRange Attribute
// Don't put this block inside document.ready function and insert it into html after jquery.validation scripts
// Check if element has data-val-date attribute,
// if yes check if inserted value is between values specified in data-val-range-min and data-val-range-max attributes,
// if no show error message from data-val-range attribute
// Source: https://stackoverflow.com/questions/21777412/mvc-model-validation-for-date
        jq.validator.methods.range = function(value, element, param): any {
            if (jq(element).attr("data-val-date")) {
                const min = jq(element).attr("data-val-range-min");
                const max = jq(element).attr("data-val-range-max");
                const date = new Date(value).getTime();
                const minDate = new Date(min).getTime();
                const maxDate = new Date(max).getTime();
                return this.optional(element) || (date >= minDate && date <= maxDate);
            }
            // use the default method
            return this.optional(element) || (value >= param[0] && value <= param[1]);
        };

// Find date input and check whether range validation attributes are set, if yes, set error message and min and max attributes
// If there exists more than one date input that has to be range validated method introduced above is used
        jq(() => {
            const input = jq("input[type=date][data-val-range-min]");

            if (!input || input.length > 1) {
                return;
            }

            const min = input.attr("data-val-range-min");
            const max = input.attr("data-val-range-max");
            const message = input.attr("data-val-range");
            if (min && max && message) {
                jq.extend(jq.validator.messages,
                    {
                        range: message,
                        max: message,
                        min: message,
                    });

                input.attr("min", min);
                input.attr("max", max);
            }
        });
    }
}
